import React, { useState } from 'react';
import { Platform } from 'react-native';
import { Header, ScreenLayout, FormHeader } from '../components';
import { VisitCampaignsList } from '../components/VisitCampaignsList';
import { useAppContext } from '../contexts/AppContext';
import { useLocale } from '../contexts/LocaleContext';
import { createTabPressHandler } from '../navigation/handleTabPress';

export const VisitCampaignsListScreen: React.FC = () => {
  const { navigateTo, activeTab, setActiveTab } = useAppContext();
  const { t } = useLocale();
  const handleTabPress = createTabPressHandler(navigateTo, setActiveTab);

  return (
    <ScreenLayout
      header={
        <Header
          showNotifications={true}
          showMessages={true}
          onNotificationPress={() => navigateTo('notifications')}
          onMessagePress={() => navigateTo('chat')}
          showNavigation={Platform.OS === 'web'}
          activeTab={activeTab}
          onTabPress={handleTabPress}
        />
      }
      showBottomTabs={Platform.OS !== 'web'}
      onLeftPaneClose={() => {}}
      leftPaneContent="settings"
      onSettingsItemPress={async (itemId) => {
        const { setPendingSettingsItem } = await import('../utils/tempStorage');
        await setPendingSettingsItem(itemId);
        navigateTo('settings');
      }}
      showRightPane={false}
      formHeader={
        <FormHeader
          title={t('visitCampaigns.list.title')}
          onBack={() => navigateTo('visits')}
          actions={[
            {
              icon: 'add-circle-outline',
              onPress: () => navigateTo('visit-campaign-create'),
              label: t('visitCampaigns.list.createCampaign'),
              primary: true,
            },
          ]}
        />
      }
    >
      <VisitCampaignsList />
    </ScreenLayout>
  );
};
